export default __webpack_public_path__ + "static/media/Immagine_1.89b199e4.jpeg";